import { PlusOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import { Button, ContentFilters, ContentTopBar } from 'components';
import { MatrialFilterFormValues, SupplierFilterForm } from 'features/master/components/master-filter-form';
import { SupplierModalView } from 'features/master/components/modal/supplier-modal';
import { useState } from 'react';
import { SideBarMenus } from 'routes/constants';
import { CompanyType } from 'types';
import { HasPermission } from 'utils/CheckPermissions';
const { useBreakpoint } = Grid;

type MatrialTopBarProps = {
  getInitialFilterValues: MatrialFilterFormValues;
  handleFilter: (values: MatrialFilterFormValues) => void;
  userEditData: any;
  showAppUserModal:any;
  setShowAppUserModal:any;
  onRefresh: () => void;
  addOrEdit:number ;
   setAddOrEdit: React.Dispatch<React.SetStateAction<number>>;
  setUserEditData: React.Dispatch<React.SetStateAction<any>>;
};

export const SupplierTopBar = ({
  getInitialFilterValues,
  handleFilter,
  userEditData,
  showAppUserModal,
  setShowAppUserModal,
  onRefresh,
  addOrEdit,
  setAddOrEdit,
  setUserEditData
 
}: MatrialTopBarProps) => {
  useState<CompanyType>();
  const formId = 'end-users-filters-form';
  const screens = useBreakpoint();

  const handleOpenModal = () => {
    setShowAppUserModal(true);
    document.body.style.overflow = 'hidden';
    setAddOrEdit(1);
  }
  const handleCloseModal = () => {
    setShowAppUserModal(false);
    document.body.style.overflow = 'visible';
    setAddOrEdit(0);
    setUserEditData(undefined);
  }

  return (
    <>
      <div className={`cstmrightmdl ${showAppUserModal && "show"}`}>
        <SupplierModalView onClose={handleCloseModal} userEditData={userEditData} addOrEdit={addOrEdit} setUserEditData={setUserEditData} />
      </div>

        {HasPermission(SideBarMenus.SUPPLIER, 'add') ? (
      <ContentTopBar title={'Customer / Supplier'}
        renderButtons={
          <div className='flex flex-nowrap"'>
            <Button
              icon={!screens.xs ? <PlusOutlined /> : undefined}
              type='primary'
              onClick={handleOpenModal}
              style={{ marginRight: 10 }}
            >
              {'Add Customer / Supplier'}
            </Button>
          </div>
        }
      />
        ):null }
        
      <ContentFilters formId={formId}>
        <SupplierFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
          onRefresh={onRefresh}
          
        />
      </ContentFilters>
    </>
  );
};
